import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { DetailAttribute, ND } from '@pt/pt-models';

@Component({
  selector: 'pt-all-attributes',
  template: `
    <div class="modal-header">
      <h4 class="modal-title">
        {{ title | async }}
      </h4>
    </div>

    <div class="modal-body">
      <ng-container *ngFor="let attribute of attributes">
        <ng-container *ngIf="!attribute.isClickable">
          <!--          <ng-container *ngIf="attribute.type !== 'CUSTOM'">-->
          <pt-details-attribute [attribute]="attribute"> </pt-details-attribute>
          <!--          </ng-container>-->

          <!--          <ng-container *ngIf="attribute.type === 'CUSTOM'">-->
          <!--            <pt-details-attribute>-->
          <!--              <div label>{{ attribute.key | async }}</div>-->
          <!--              <div-->
          <!--                value-->
          <!--                [innerHTML]="attribute.value | replaceNullWithText : ND"-->
          <!--              ></div>-->
          <!--            </pt-details-attribute>-->
          <!--          </ng-container>-->
        </ng-container>
      </ng-container>
    </div>

    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-outline-secondary btn-sm"
        (click)="activeModal.close(false); $event.stopPropagation()"
      >
        {{ 'BUTTON.CLOSE' | translate }}
      </button>
    </div>
  `,
})
export class ShowAllAttributesDialogComponent {
  @Input() title: Observable<string>;
  @Input() attributes: DetailAttribute[];
  ND = ND;

  constructor(public activeModal: NgbActiveModal) {}
}
